import { practiceAreas } from "@/mocks/lawfirm";

export default function Practice() {
  return (
    <section id="practice" className="py-16 md:py-24 bg-primary-950 text-white">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <p className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-medium text-accent-300 tracking-wide">
            <i className="ri-layout-grid-line"></i>
            PRACTICE AREAS
          </p>
          <h2 className="mt-5 font-heading text-2xl md:text-4xl font-bold leading-snug md:leading-[1.5]">
            <span className="md:hidden">
              광주부장판사·검사출신변호사가
              <br />
              다루는 <span className="text-accent-400">수행사건</span> 분야
            </span>
            <span className="hidden md:inline">
              광주부장판사·검사출신변호사가 다루는
              <br />
              <span className="text-accent-400">수행사건</span> 분야
            </span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-white/70">
            형사부터 민사·가사·기업법무·회생파산까지, 재판의 흐름을 아는 변호사와 함께 원스톱으로 해결합니다.
          </p>
        </div>

        {/* 모바일: 태그 구름(가변 폭 칩)으로 압축 */}
        <div className="mt-10 flex flex-wrap justify-center gap-2 sm:hidden">
          {practiceAreas.map((area) => (
            <div
              key={area.id}
              className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3.5 py-2 transition-colors duration-300 hover:border-accent-500/40 hover:bg-white/10"
            >
              <i className={`${area.icon} text-sm text-accent-300`}></i>
              <span className="text-sm font-medium text-white whitespace-nowrap">
                {area.title.replace(/\s*\([^)]*\)/g, "")}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-12 mx-auto hidden max-w-6xl grid-cols-1 gap-4 sm:grid sm:grid-cols-2 md:gap-5 lg:grid-cols-3 xl:grid-cols-4">
          {practiceAreas.map((area) => (
            <div
              key={area.id}
              className="group flex items-center gap-3 rounded-lg border border-white/10 bg-white/5 px-5 py-4 text-left transition-colors duration-300 hover:border-accent-500/40 hover:bg-white/10"
            >
              <span className="flex items-center justify-center w-11 h-11 shrink-0 rounded-md bg-accent-500/15 text-accent-300 transition-colors duration-300 group-hover:bg-accent-500/25">
                <i className={`${area.icon} text-xl`}></i>
              </span>
              <span className="flex-1 text-base font-semibold text-white whitespace-nowrap overflow-hidden text-ellipsis">
                {area.title.replace(/\s*\([^)]*\)/g, "")}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}